import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  actionsCell: ({ numberOfActions }) => ({
    width: `${numberOfActions * 2.5}rem`,
    textAlign: 'right',
    padding: 0,
  }),
}));

export default useStyles;
